<template>
    <div class="rightContent">
        <div class="rightTitle clear">
            <div class="colorLump"></div>
            <div class="title">创建课程</div>
        </div>
        <div class="main createNewCourseBox flex">
            <!-- <router-link to="addKc" class="createNewCourse">创建新课程+</router-link> -->
            <router-link to="addKc" class="createNewCourse">创建线上新课程+</router-link>
            <router-link to="addxxKc" class="createNewCourse">创建线下新课程+</router-link>
            </div>
            <div class="orgTopNavBox">
                <div class="search-condition">
                    <div class="cour-con clear">
                        <div class="borders clear">
                            <div class="line"></div>
                            <div class="item" style="width: 90px;">
                                <span :class=" query.status == ''? 'cons actived':'cons'" @click="bindTab()">全部课程</span>
                            </div>
                            <div class="item" style="width: 90px;">
                                <span :class=" query.status == -20? 'cons actived':'cons'" @click="bindTab(-20)">待提交</span>
                                <span class="red_circle" v-if="listData.dtjCount > 0">{{ listData.dtjCount }}</span>
                            </div>
                            <div class="item" style="width: 90px;">
                                <span :class=" query.status == -10? 'cons actived':'cons'" @click="bindTab(-10)">待审核</span>
                                <span class="red_circle" v-if="listData.dshCount > 0">{{ listData.dshCount }}</span>
                            </div>
                            <div class="item" style="width: 110px;">
                                <span :class=" query.status == '0'? 'cons actived':'cons'" @click="bindTab('0')" >审核不通过</span>
                                <span class="red_circle" v-if="listData.btgCount > 0">{{ listData.btgCount }}</span>
                            </div>
                            <div class="item" style="width: 90px;">
                                <span :class=" query.status == 10? 'cons actived':'cons'" @click="bindTab(10)">审核通过</span>
                                <span class="red_circle" v-if="listData.tgCount > 0">{{ listData.tgCount }}</span>
                            </div>
                        </div> 
                        <span class="searchBox flex" >
                            <el-input v-model="query.search" placeholder="请输入课程名称或课程编号" />
                            <span class="search-font"  @click="getList(1)">搜索</span>
                            <span class="zero"  @click="bindReset">↻重置</span>
                            <el-select v-model="typeDataDefault" placeholder="请选择类型" clearable>
                                <el-option 
                                v-for="dict in typeData.list" 
                                :key="dict.id" 
                                :label="dict.name"
                                :value="dict.id" 
                                @click = "courseTypeClick()"/>
                            </el-select>
                        </span>
                    </div>
                </div>
            </div>
            <div class="result">
                <div class="courList" v-for="item in listData.list" :key="item.id">
                    <ul>
                        <li class="cour-div">
                            <div class="cour-top">
                                <span class="cour-tap">课程编号：{{ item.id }}</span> 
                                <span class="cour-number">招生人数：{{ item.lowerLimit }}-{{ item.upperLimit }}</span>
                                <span class="cour-type download">{{ item.type == 0? '在线课程':'线下课程'}}</span>
                                <router-link class="cour-same" :to="{path:'khyq',query:{id:item.id,listType:1}}">考核要求</router-link>
                                <span class="cour-take">操作</span>
                                <span class="cour-status">状态</span>
                            </div>
                            <div class="cour-content">
                                <span class="cour-info">
                                    <div class="info-title">{{ item.name }}</div>
                                    <div class="info-min">
                                        <div><span>开课时间</span>：{{ item.startTime }}至{{ item.endTime }}</div>
                                        <div><span>课程费用</span>：{{ item.money }} </div>
                                        <div><span>学分</span>： {{ item.credit }} </div>
                                    </div>
                                </span> 
                                <span class="cour-sta">
                                    <div class="tableBox">
                                        <div class="subing">{{ item.statusMsg }}</div>
                                    </div>
                                </span> <span class="courtake">
                                    <div class="tableBox">
                                        <!-- <router-link class="edit rates" :to="{path:'addKc',query:{id:item.id} }" v-if="query.status == -20 || query.status == '0'">修改课程</router-link> -->
                                        <router-link class="edit rates" :to="{path:'addKc',query:{id:item.id} }" v-if="(query.status == -20 || query.status == '0')&(item.type == 0)">修改课程</router-link>
                                        <router-link class="edit rates" :to="{path:'addxxKc',query:{id:item.id} }" v-if="(query.status == -20 || query.status == '0')&(item.type == 10)">修改课程</router-link>
                                        <div v-if="query.status == -20" class="edit rates" @click="bindSh(item.id)">提交审核</div>
                                    </div>
                                </span>
                            </div>
                        </li>
                    </ul>
                </div>
                <div v-if="!listData.list.length" class="emptyBox">暂无数据</div>
            </div>
            <el-pagination v-if="listData.list.length" background layout="prev, pager, next" :total="listData.total" :page-size="query.pageSize" @current-change="bindPage" />
        </div>
</template>
<script setup>
import { ref,reactive,getCurrentInstance } from 'vue'
import { getCourseList,toexamizate,getCourseTypeList } from '../../server/jigou/course'

const { proxy } = getCurrentInstance()
const query = reactive({
    status: '',//1待提交 2待审核 3审核不通过 4审核通过
    search: '',
    pageSize: 10,
    pageNum: 1,
    type:'',
})
const listData = reactive({
    list:[],
    total:0,
    tgCount:'',
    btgCount:'',
    dshCount: '',
    dtjCount: '',
})
//课程类型
const typeData = reactive({
    list:[],
})
const typeDataDefault = ref('')
//获取课程评分列表
async function getList(page){
    if( page ){
        query.pageNum = page
    }
    query.type = typeDataDefault.value
    if (query.type == '') {
        delete query.type   
    }
    let res = await getCourseList(query)
    if( res != false ){
        listData.list = res.list
        listData.total = res.total
        listData.tgCount = res.tgCount
        listData.btgCount = res.btgCount
        listData.dtjCount = res.dtjCount
        listData.dshCount = res.dshCount
    }
}
//获取课程类型数据
async function getCourseTypeListData(){
    let res = await getCourseTypeList()
    if( res != false ){
        typeData.list = res
    }
}
function courseTypeClick(){
    getList(1)
}
getList()
getCourseTypeListData()
//tab切换
function bindTab(id){
    query.status = id || ''
    getList()
}
//重置
function bindReset(){
    query.search = ''
    query.type = ''
    query.status = ''
    query.pageNum = 1
    typeDataDefault.value = ''
    getList()
}
//分页
function bindPage(e){
    console.log('页数:',e)
    query.pageNum = e
    getList()
}
//提交审核
const shQuery =reactive({
    id:''
})
async function bindSh(id){
    shQuery.id = id
    let res = await toexamizate(shQuery)
    if( res != false ){
        proxy.$modal.msgSuccess("提交审核成功");
        getList()
    }
}
</script>
<style scoped>
.zero{
    display: inline-block;width: 100px;
}
.searchBox{
    align-items: center;
}
.createNewCourseBox .createNewCourse{
    margin-right: 20px;
}
</style>